import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationType } from '../types/ConnectedApplicationType';
import { API_VERSION, EAS_PATH } from './RestApiConstants';


export interface IGetConnectedApplicationEasResult extends IResult {
    externalAuthorizationServer: IConnectedApplicationType;
}

function getConnectedApplicationEasRequestConfig(id: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'GET',
    endpoint: `${EAS_PATH}/${id}`,
    serverWideRequest: false
  };
}

export function callGetConnectedApplicationEas(id: string): Promise<IGetConnectedApplicationEasResult> {
  return makeJsonRestApiRequest<void, IGetConnectedApplicationEasResult>({
    config: getConnectedApplicationEasRequestConfig(id),
    request: null,
  });
}